<template src="./AutogestionPaciente.html"></template>

<script>
import {
  consultarFormulariosExistentes,
  consultarFormulario,
  consultarEstructuraFormularioPorId
} from "../../apiService/request/crudFormulario";
import TarjetasNuevasMomento from "../TarjetasNuevasMomento/TarjetasNuevasMomento";
import DatePicker from "../DatePicker/DatePicker";
// import { validarUsuario } from "../../apiService/request/crudUsuario";
import { obtenerPlanesTrabajo } from "../../apiService/request/crudPlanesTrabajo";
// import axios from "../../apiService/config/axios";
import moment from "moment";
export default {
  data() {
    return {
      texto_introductorio: null,
      valid: true,
      cedulaPaciente: "",
      fechaExpedicion: null,
      reglasObligatorio: [v => !!v || "Campo obligatorio"],
      cedulaPacienteRules: [
        v =>
          !!v ||
          "Este campo no debe estar vacío, ni contener letras o caracteres.",
        v =>
          (v && v.length <= 16) ||
          "Este campo no puede tener más de 15 números",
        v => (v && v.length >= 4) || "Este campo debe tener al meos 4 números"
      ],
      flagNoFormularios: false,
      listaFormularios: [],
      listaPlanesTrabajo: [],
      formularioActual: null,
      idFormulario: null,
      nombreFormulario: null,
      variablesFormulario: [],
      coleccion: null // Permite distinguir si es un formulario/cuestionario
    };
  },
  computed: {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    limpiarListaFormularios() {
      this.listaFormularios = [];
    },
    limpiarListaPlanesTrabajo() {
      this.listaPlanesTrabajo = [];
    },
    async validate() {
      if (this.$refs.form.validate()) {
        await this.limpiarData();
        // await this.consultarFormulariosExistentesPaciente();
      }
    },
    async limpiarData() {
      this.formularioActual = null;
      this.idFormulario = null;
      this.nombreFormulario = null;
      this.variablesFormulario = null;
      this.coleccion = null;
      this.limpiarListaFormularios();
      this.limpiarListaPlanesTrabajo();
      await this.consultarFormulariosExistentesPaciente();
      await this.consultarPlanesTrabajo();
    },
    /**
     * Se consulta (POST al back-end) por la lista de cuestionarios/formularios que tiene una cédula asociados
     */
    async consultarFormulariosExistentesPaciente() {
      try {
        if (
          this.$store.getters.getCedulaPaciente != Number(this.cedulaPaciente)
        ) {
          this.$store.dispatch(
            "setCedulaPaciente",
            Number(this.cedulaPaciente)
          );
        }
        if (!this.$store.getters.getCargando) {
          this.$store.dispatch("setCargando", true);
        }
        // const responseAuth = await validarUsuario(
        //   this.cedulaPaciente,
        //   this.fechaExpedicion
        // );
        // if (responseAuth && responseAuth.data && responseAuth.data.data) {
        // sessionStorage.setItem("token", responseAuth.data.data.token);
        // sessionStorage.setItem(
        //   "refreshToken",
        //   responseAuth.data.data.refreshToken
        // );
        //   sessionStorage.setItem("expiresIn", responseAuth.data.data.expiresIn);
        //   sessionStorage.setItem("nombre", responseAuth.data.data.nombre);
        //   sessionStorage.setItem("apellido", responseAuth.data.data.apellido);
        //   axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem(
        //     "token"
        //   )}`;
        // }
        const respuesta = await consultarFormulariosExistentes(
          Number(this.cedulaPaciente)
        );
        if (respuesta.data.data && respuesta.data.data.length > 0) {
          this.listaFormularios = respuesta.data.data;
        } else {
          this.$store.dispatch("cambiarEstadoModal", true);
          this.$store.dispatch("cambiarMensajeModal", {
            status: 400,
            data: {
              message:
                "No se encontraron formularios asociados con el documento ingresado"
            }
          });
        }
      } catch (err) {
        console.log("error consultando lista formularios", err.message);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    async consultarPlanesTrabajo() {
      try {
        if (!this.$store.getters.getCargando) {
          this.$store.dispatch("setCargando", true);
        }
        const respuesta = await obtenerPlanesTrabajo(
          Number(this.cedulaPaciente)
        );
        if (
          respuesta &&
          respuesta.data &&
          respuesta.data.data &&
          respuesta.data.data.variables
        ) {
          this.listaPlanesTrabajo = respuesta.data.data.variables;
        } else {
          console.error("error consultando la lista de planes de trabajo");
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    /**
     * 1.
     * Se consulta por un cuestionario específico (POST), de esta manera
     * el back-end crea el formulario en la base de datos, y nos retorna
     * el docId asociado.
     *
     * 2.
     * Se consulta a partir del docId, la estructura del cuestionario
     */
    async consultarFormularioPaciente(formulario) {
      this.$store.dispatch("setCargando", true);
      const respuesta1 = await consultarFormulario(
        formulario,
        this.$store.getters.getCedulaPaciente
      );
      await this.consultarEstructuraFormulario(
        respuesta1.data.data.docId,
        formulario
      );
    },
    /**
     * Se consulta por la estructura de un cuestionario/formulario GET (no necesita tipo_esquema)
     * se consulta solo por docID y  esquema
     */
    async consultarEstructuraFormulario(docId, formulario) {
      try {
        const respuesta2 = await consultarEstructuraFormularioPorId(
          docId,
          formulario
        );
        this.idFormulario = docId;
        this.formularioActual = formulario;
        this.variablesFormulario = respuesta2.data.data.variables;
        this.nombreFormulario = respuesta2.data.data.key;
        this.coleccion = respuesta2.data.data.coleccion;
        if (respuesta2.data.data.texto_introductorio) {
          this.texto_introductorio = respuesta2.data.data.texto_introductorio;
        } else {
          this.texto_introductorio = null;
        }
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    abrirPlanTrabajo(planTrabajo) {
      window.open(planTrabajo.url);
    }
  },
  filters: {
    formatoFechaHora: function(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    }
  },
  components: {
    TarjetasNuevasMomento,
    DatePicker
  }
};
</script>

<style lang="scss" src="./AutogestionPaciente.scss" scoped></style>
<style lang="scss">
.inputNumero {
  .v-input__control {
    .v-input__slot {
      box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
        0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
    }
  }
}
</style>
